import { HttpEvent, HttpHandlerFn, HttpHeaders, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { DomainService } from './domain.service';

/**
 * An HTTP client interceptor, that adds the required authRealm headers to the request.
 * It sets the 'x-cdf-auth-realm' header, which is used in the backend determining the WEN realm
 * for checking the user's authentication. Sending the wrong realm, will result in an HTTP 403 response.
 * Not sending the header will also result in an HTTP 403 response.
 * Headers are only added, when the request targets the configured 'environment.backendUrl'.
 */
export function authRealmHeaderInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const domainService = inject(DomainService);
  const realmHeader = 'x-cdf-auth-realm';

  let headers: HttpHeaders;
  if (domainService.isInternetUrl(req.url)) {
    headers = req.headers.set(realmHeader, 'internetb2x');
  } else if (domainService.isIntranetUrl(req.url)) {
    headers = req.headers.set(realmHeader, 'intranetb2x');
  } else {
    return next(req);
  }

  const reqWithHeaders = req.clone({ headers });
  return next(reqWithHeaders);
}
